export default __webpack_public_path__ + "static/media/checked.6f3ecf4f.svg";